/** @format */

import React from 'react';
import { SimpleSelect, SimpleSelectElements } from '../../../components/Adescom/SimpleSelect';
import { useDispatch } from 'react-redux';
import { VatCollectionInterface } from '../../../interfaces/collections/VatCollectionInterface';

interface InvoiceVatPropsInterface {
    changeVatCallback: (event: React.ChangeEvent<HTMLSelectElement>) => void;
    vat: string;
    vats: VatCollectionInterface;
    disabled: boolean;
}

const InvoiceVat: React.FC<InvoiceVatPropsInterface> = (props) => {
    const dispatch = useDispatch();

    const saveCallback = (event: React.ChangeEvent<HTMLSelectElement>): void => {
        props.changeVatCallback(event);
    };

    const preprocessUri = (uri: string): string => {
        if(uri.startsWith('/api/')) {
            return uri;
        }

        return '/api/' + uri.split('/api/')[1];
    };

    return (
        <>
            {props.vats && props.vats['hydra:member'] && (
                <SimpleSelect
                    label={'documents:invoices.tax_percentage'}
                    required={true}
                    elements={props.vats['hydra:member'].map((el) => {
                        return {
                            name: `${el.description}`,
                            value: preprocessUri(el['@id']),
                        } as SimpleSelectElements;
                    })}
                    dispatchName={'vat'}
                    fieldName={'vat'}
                    selectedValue={preprocessUri(props.vat)}
                    callback={saveCallback}
                    disabled={props.disabled}
                />
            )}
        </>
    );
};

export default InvoiceVat;
